import React, { Component, useContext, useEffect } from "react";
import IQBDSyncCatalogItemsStartDTO from "../../../../models/DTO/IQBDSyncCatalogItemsStartDTO";
import IQBDSyncCatalogItemsUpdateDTO from "../../../../models/DTO/IQBDSyncCatalogItemsUpdateDTO";
import EndpointsEnum from "../../../../models/EndpointsEnum";
import OwLabel from "../../../shared/OwLabel/OwLabel";
import { Socket } from "socket.io-client";
import IUiSocketSetup from "../../../../models/IUiSocketSetup";
import { SocketContext } from "../../../../contexts/SocketContext";
import IQBDSyncCatalogProcessingDTO from "../../../../models/DTO/IQBDSyncCatalogProcessingDTO";

type Props = {};

type State = {
    totalItems: number;
    totalProcessed: number;
    lineWidth: number;
};

export const QBDItemsSyncStatus = (props: Props) => {
    const socket = useContext(SocketContext);

    const [section, setSection] = React.useState<IQBDSyncCatalogProcessingDTO["section"]>();
    const [totalItems, setTotalItems] = React.useState<number>(0);
    const [totalProcessed, setTotalProcessed] = React.useState<number>(0);
    const [lineWidth, setLineWidth] = React.useState<number>(0);

    const qbdCatalogProcessing = (data: IQBDSyncCatalogProcessingDTO) => {
        if (data.currentItem && data.totalItems) {
            const _lineWidth = (data.currentItem / data.totalItems) * 100;
            setLineWidth(_lineWidth);
        }

        if (data.totalItems) {
            setTotalItems(data.totalItems);
        }

        if (data.currentItem) {
            setTotalProcessed(data.currentItem);
        }

        if (data.section) {
            setSection(data.section);
        }
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.QBDSyncCatalogItemsProcessing, fn: qbdCatalogProcessing }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket?.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket?.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    return (
        <div className="QBDItemsSyncStatus">
            <div>
                <OwLabel title={"section"} postText={":"} className={"me-3"} />
                {section}
            </div>
            <div>
                <OwLabel title={"processing"} noBottomMargin={true} postText={":"} className={"me-3"} />
                {totalProcessed} <OwLabel title={"of"} noBottomMargin={true} /> {totalItems}
            </div>
            <div className={"bg-warning"} style={{ height: "3px", width: `${lineWidth}%` }}></div>
        </div>
    );
};
